// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("catalog-products/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
};
